<template>
  <edn-skeleton-template type="field" v-if="$attrs.isLoading"></edn-skeleton-template>
  <v-text-field
    v-else 
    ref="edn-field-input"
    autocomplete="off"
    spellcheck="false"
    v-on="$listeners"
    v-bind="$attrs"
    type="text"
    v-model="Value"
    :rules="rules"
    @click:append="focusOnInput"
    :append-icon="getAppendedIcon"
    :disabled="getIrisRdonlyMode || $attrs.disabled"
    :filled="$attrs.filled || getIrisRdonlyMode "
    :class="[getIrisCssClass,getTextTransform,getValidationClass]"
    :outlined="isValidated"
    :color="isValidated ? 'success':''"
    :dense="isValidated"
    :style="inputCss"
  >
    <template v-slot:append v-if="isThereAnIcon">
      <slot name="appendIcon">
        <v-icon
          v-if="isCustomIcon"
          :size="iconProps.size" 
          :color="getAppendIconColor"
        >{{ getAppendIcon }}</v-icon>
        <v-icon
          v-else
          :size="validatedIcon.size" 
          :color="validatedIcon"
        >{{ validatedIcon.icon }}</v-icon>
      </slot>
    </template>
    <template v-slot:label>
      <div 
        class="d-flex align-center"
        :style="{ color : $attrs.labelColor ? $attrs.labelColor : '' }"
      >
        <span>{{ $attrs.label }} </span>
        <span v-if="fldRequiredVal && !$attrs.readonly" class="red--text ml-1 edn-field--required">*</span>
        <edn-tooltip color="transparent" v-if="!!$attrs.tooltip" activatorClass="ml-1" :iconSize="tooltipIconSize"> 
          <v-card elevation="2" class="edn-tooltip__card" >
              <slot name="content">            
                <v-card-text>{{ $attrs.tooltip }}</v-card-text>
              </slot>
          </v-card>
        </edn-tooltip>
      </div>
    </template>
    <template v-slot:append-outer>
      <slot v-bind:url="$attrs.url" name="edn-append-outer"></slot>
    </template>
  </v-text-field>
</template>

<script>
import { ednRegex } from './mixins/ednRegex'
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'
import ednTooltip  from './ednTooltip'
import { ednTransform } from './mixins/ednTransform'
import { ednValue } from './mixins/ednValue'

export default {
  inheritAttrs: false,
  mixins: [ednMimicMix, ednTransform, ednRequired, ednRegex, ednValue],
  components: {
    ednTooltip,
  },
  props: {
    pattern: {
      type: RegExp
    },  
    required:{
      type:[String, Boolean],
      default : ()=> false
    },
    value: null,
    isValidated:{
      type: Boolean
    },
    iconSmall: {
      type: Boolean,
      default: () => false,
    },
    tooltipIconSize: {
      type: [String, Number],
      default: () => '1.375rem',
    },
    /** css properties of the append icon */
    iconProps: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
  },
  data(){
    return{
      validatedIcon: {
          size:13,
          color:"primary",
          icon:"mdi-check"
        },
    }
  },
  computed: {
    inputCss() {
      if (this.$attrs.valueColor) {
        return {
          color : this.$attrs.valueColor ? this.$attrs.valueColor : ''
        };
      }
      return '';
    },
    /** Position de l'icône de validation */
    validIcon(){
      return this.$attrs.tooltip && !this.$attrs.rdonly ? 'append' : 'append';
    },
    /** classe Css à la validation du champs */
    getValidationClass(){
      return this.isValidated ? 'edn-validated green--text v-input--is-focused' : 'edn-field'
    },
    /** Check if there an icon to append to the field */
    isThereAnIcon () {
      return this.isValidated || !!this.iconProps.icon
    },
    isCustomIcon(){
      return !!this.iconProps.icon
    },
    /** Check which append icon should we use */
    getAppendIcon(){
      return this.iconProps.icon
    },
    /** Check which append icon color should we use */
    getAppendIconColor(){
      if(this.isValidated) return 'success';
      if(this.iconProps?.color) return this.iconProps?.color;
      return 'primary'
    }
  },
  watch:{
    required:function(val){
      this.$emit('requiredChange',val)
    }
  },
}
</script>

<style scoped>
.edn-validated >>> .v-text-field__slot{
  padding: 5px 0 5px 0;
  margin-top: 4px;
  height:47px;
}

.edn-validated >>> .v-input__slot{
  padding: 0 !important;
}

.edn-validated >>> fieldset{
  left:-12px;
  bottom:2px;
}

.edn-validated >>>  input{
    position: relative;
    top: 5px;
}

.edn-validated.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__append-inner{
    margin-top: 13px;
    margin-right: 11px;
}
</style>
